import { MessageCircleQuestion } from "lucide-react";
import { useTranslation } from "react-i18next";

const SupportButton = () => {
  const { t } = useTranslation();
  
  const handleSupportClick = () => {
    const email = "kontakt@loops-cycling-academy.de";
    const subject = encodeURIComponent("Supportanfrage Velometrics");
    window.location.href = `mailto:${email}?subject=${subject}`;
  };

  return (
    <button
      onClick={handleSupportClick}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-4 py-3 bg-zinc-800 hover:bg-zinc-700 border border-zinc-600 hover:border-volt text-white rounded-full shadow-lg transition-all duration-300 hover:scale-105 group"
      data-testid="support-button"
      title={t('support.tooltip', 'Support kontaktieren')}
    >
      <MessageCircleQuestion className="h-5 w-5 text-volt" />
      <span className="text-sm font-medium hidden sm:inline">Support</span>
    </button>
  );
};

export default SupportButton;
